import { InfoLanguage } from "@bandido/shared/enums";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LoadingButton } from "@mui/lab";
import { Box, useTheme } from "@mui/material";

import { useTranslation } from "react-i18next";

import { languages } from "./constants";
import { EditorBox } from "./EditorBox";

export const MultiLanguageInstructionsEditor = ({
  values,
  onChange,
  placeholder,
  onGenerateWithAI,
  isGeneratingTranslations
}: {
  values: Record<InfoLanguage, string>;
  onChange: (language: InfoLanguage, data: string) => void;
  placeholder: string;
  onGenerateWithAI?: () => void;
  isGeneratingTranslations: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  return (
    <Box>
      {languages.map((lang, index) => (
        <Box key={lang.code} marginBottom={3}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 2,
          }}>
            <img style={{ width: '20px', height: '15px' }} src={lang.flag} alt={lang.name} />
            {onGenerateWithAI && index === 0 && (
              <LoadingButton
                variant="outlined"
                color="primary"
                size="small"
                disabled={values[lang.code] === ''}
                onClick={onGenerateWithAI}
                loading={isGeneratingTranslations}
                sx={{
                  borderRadius: theme.shape.borderRadius,
                  textTransform: 'none',
                  fontWeight: theme.typography.fontWeightMedium,
                }}
              >
                {t('hotelContent.view.checkinCheckout.generateWithAI')}
              </LoadingButton>
            )}
          </Box>
          <EditorBox>
            <CKEditor
              editor={ClassicEditor as any}
              data={values[lang.code] || ''}
              onChange={(_: any, editor: any) => {
                if(!isGeneratingTranslations) {
                  const data = editor.getData();
                  onChange(lang.code, data);
                };
              }}
              config={{
                placeholder: `${placeholder} (${lang.name})`,
                toolbar: ['bold', 'italic', 'underline', 'unorderedList', 'undo', 'redo']
              }}
            />
          </EditorBox>
        </Box>
      ))}
    </Box>
  );
};
